<template>
  <div>
    <v-card class="px-6 pt-6 pb-5" outlined>
      <v-layout wrap>
        <v-flex v-if="!user.company.isActive" pb-3 text-center>
          <div class="mb-2">
            <v-chip class="white--text" color="primary">
              <v-avatar  color="secondary" size="3" class="mr-2">
                <v-icon small icon="mdi-lock" color="white">mdi-lock</v-icon>
              </v-avatar>
              <span>{{ $t('c') }}</span>
            </v-chip>
          </div>
        </v-flex>
        <v-flex v-else-if="dossier.status === 'error' && !dossier.isErased">
          <v-layout wrap justify-space-around pt-2 mb-3>
            <v-flex xs10 text-center>
              <small>
                <div>{{ $t('e') }}</div>
                <div>{{ $t('f') }}</div>
                <!-- <div v-if="dossier.isProfileReady && isMyDossier || ['editable'].includes(dossier.sharingMode)"><b>{{ $t('f3') }}</b></div> -->
              </small>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout wrap v-if="dossier.isErased">
        <v-flex xs6>
          <small>
            <b>{{ $t('erased') }}</b>
          </small>
        </v-flex>
        <v-flex xs6 text-end>
          <small>
            <span>{{ $t('a') }} {{ displayDate(dossier.createdAt) }}</span>
            <span v-if="dossier.userEmail || dossier.invitedConsultantEmail"> {{ $t('4') }} {{ dossier.userEmail || dossier.invitedConsultantEmail }}</span>
            <span v-else> {{ $t('4ter') }}</span>
          </small>
        </v-flex>
      </v-layout>

      <v-layout wrap v-else>
        
        <v-flex xs12 v-if="dossier.invitedConsultantEmail">
          <v-layout wrap :class="{ 'mb-2': dossier.profile }">
            <v-flex xs10>
              <v-chip small v-on="isMyDossier ? { click: () => showUpdateSharingModeDialog('consultant') } : {}">
                <v-icon small class="mr-2">mdi-link-variant</v-icon>
                {{ $t('x1') }} - {{ dossier.invitedConsultantEmail }}
                <v-avatar v-if="isMyDossier" right>
                  <v-icon small>mdi-pen</v-icon>
                </v-avatar>
              </v-chip>
            </v-flex>
            <v-flex xs2 text-end>
              <div v-if="!dossier.profile && (isMyDossier || ['editable'].includes(dossier.sharingMode))">
                <v-btn x-small fab :elevation="0" rounded @click="isShowingArchiveDossier = true">
                  <v-icon small class="grey--text">mdi-delete</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
          <v-layout wrap mt-3 v-if="!dossier.profile">
            <v-flex xs6 pl-1 style="margin-top:2px">
              <small>
                {{ $t('x2') }}
              </small>
            </v-flex>
            <v-flex xs6 text-end pt-1>
              <small>
                <span>{{ $t('a') }} {{ displayDate(dossier.createdAt) }}</span>
                <span v-if="dossier.userEmail || dossier.invitedConsultantEmail"> {{ $t('4') }} {{ dossier.userEmail || dossier.invitedConsultantEmail }}</span>
                <span v-else> {{ $t('4ter') }}</span>
              </small>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 v-if="dossier.profile">
          <v-layout wrap>
            <v-flex xs6>
              <div>
                <strong>
                  <ais-highlight :hit="dossier" attribute="profile.firstName"/>&nbsp;
                  <ais-highlight :hit="dossier" attribute="profile.lastName"/>
                </strong>
              </div>
              <div><small><ais-highlight :hit="dossier" attribute="profile.title"/></small></div>
              <div v-if="dossier.profile.xpYears">
                <small>
                  {{ dossier.profile.xpYears }}
                  <span v-if="dossier.profile.xpYears > 1"> {{ $t('1plural') }}</span>
                  <span v-else> {{ $t('1') }}</span>
                </small>
              </div>
              <div v-if="dossier.labelIds">
                <v-chip label v-for="(labelId, key) in dossier.labelIds" :key="key" class="mr-3" small>
                  <span v-if="getLabelById(labelId)">{{ getLabelById(labelId).name }}</span>
                </v-chip>
              </div>
            </v-flex>
            <v-flex xs6>
              <v-layout text-end wrap justify-space-around class="pl-12">
                <v-flex xs6>
                  <v-btn v-if="dossier.status === 'done' && (isMyDossier || ['editable', 'downloadable'].includes(dossier.sharingMode))" small class="secondary pl-3 pr-4" @click="downloadDossier" :disabled="!user.company.isActive">
                    <v-icon small class="mr-2">mdi-download</v-icon>&nbsp;
                    <span>{{ $t('g') }}</span>
                  </v-btn>
                </v-flex>
                <v-flex xs6>
                  <v-btn v-if="isMyDossier || ['editable'].includes(dossier.sharingMode)" small :to="editDossierRouterPath" outlined class="pl-3 pr-4" >
                    <v-icon small class="mr-2">mdi-pen</v-icon>&nbsp;
                    <span>{{ $t('edit') }}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 mt-5>
              <div >
                <div v-if="isShowingAllTechnicalSkillNames">
                  <small>
                    <div v-for="(category, key) in dossier.profile.skills.technicalSkillsWithText.categories" :key="key" class="mt-3">
                      <div><b>{{ category.name }} :</b></div>
                      <div>{{ category.text }}</div>
                    </div>
                  </small>
                  <div>
                    <small><a @click="isShowingAllTechnicalSkillNames = false" class="textAsLink">{{ $t('2') }}</a></small>
                  </div>
                </div>
                <div v-else-if="dossier.profile.skills.technicalSkillsWithText.mainSkillNames.length > 0">
                  <v-chip small v-for="(skill, key) in dossier.profile.skills.technicalSkillsWithText.mainSkillNames.slice(0,5)" :key="key" class="mr-2 mb-1">
                    {{skill}}
                  </v-chip>
                  <small v-if="dossier.profile.skills.technicalSkillsWithText.mainSkillNames.length > 5"><a @click="isShowingAllTechnicalSkillNames = true" class="textAsLink">{{ $t('3') }}</a></small>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 mt-4 v-if="dossier.profile.languages.length > 0">
              <small>
                <table>
                  <tr v-for="(language, key) in dossier.profile.languages" :key="key">
                    <td>
                      {{ getLanguageName(language.code) }}
                    </td>
                    <td class="pl-2">
                      <span v-if="language.levelNb || language.levelNb === 0 ">
                        <v-icon x-small v-for="(_, key) in language.levelNb + 1" :key="`level-on-${key}`">mdi-circle</v-icon>
                        <v-icon x-small v-for="(_, key) in 4 - language.levelNb" :key="`level-off-${key}`">mdi-circle-outline</v-icon>
                      </span>
                    </td>
                  </tr>
                </table>
              </small>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <v-layout wrap>
                <v-flex xs6>
                  <div v-if="wasDossierTranslated" class="mt-2"><small>{{ translatedToStr }}</small></div>
                </v-flex>
                <v-flex xs6 text-end>
                  <v-btn v-if="isMyDossier" x-small dense outlined @click="showUpdateSharingModeDialog('team')" class="mr-12 primary--text">
                    <v-icon small class="mr-2">mdi-link-variant</v-icon>
                    <span>{{ $t('sharingMode0') }}</span>
                  </v-btn>
                  <small v-else class="primary--text" :class="{ 'mr-12': dossier.sharingMode === 'editable' }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small class="mr-2" v-bind="attrs" v-on="on">mdi-link-variant</v-icon>
                      </template>
                      <div>{{ $t('sharingMode1') }} <b>{{ getSharingModeAsStr(dossier.sharingMode) }}</b></div>
                      <div>{{ getSharingModeDescriptionAsStr(dossier.sharingMode) }}</div>
                    </v-tooltip>
                  </small>
                  <v-btn v-if="isMyDossier || ['editable'].includes(dossier.sharingMode)" x-small fab :elevation="0" rounded @click="isShowingArchiveDossier = true">
                    <v-icon small class="grey--text">mdi-delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs4>
                  <small v-if="isMyDossier || ['editable', 'downloadable'].includes(dossier.sharingMode)">
                    <div v-if="isDownloadingOriginalCV">
                      <v-progress-linear color="primary" indeterminate class="mt-2"/>
                    </div>
                    <div v-else>
                      <a @click="downloadOriginalCV" class="textAsLink">{{ $t('b') }}</a>
                    </div>
                  </small>
                </v-flex>
                <v-flex xs8 text-end>
                  <small>
                    <span>{{ $t('a') }} {{ displayDate(dossier.createdAt) }}</span>
                    <span v-if="dossier.userEmail || dossier.invitedConsultantEmail"> {{ $t('4') }} {{ dossier.userEmail || dossier.invitedConsultantEmail }}</span>
                    <span v-else> {{ $t('4ter') }}</span>
                  </small>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

    </v-card>

    <v-dialog v-model="isShowingArchiveDossier" width="40%" :persistent="erasingDossierStatus === 'pending'">
      <v-card class="pa-6">
        <div v-if="erasingDossierStatus === 'notStarted'">
          <v-layout wrap>
            <v-flex xs12 text-center>
              <h3>{{ $t('5') }}</h3>
            </v-flex>
            <v-flex xs12 my-3>
              <small>{{ $t('6') }}</small>
            </v-flex>
          </v-layout>
          <v-layout wrap mt-3>
            <v-flex xs6 text-center>
              <v-btn class="primary" @click="eraseDossier">{{ $t('7') }}</v-btn>
            </v-flex>
            <v-flex xs6 text-center>
              <v-btn outlined @click="isShowingArchiveDossier = false">{{ $t('8') }}</v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="erasingDossierStatus === 'pending'">
          <v-layout wrap>
            <v-flex xs12 text-center>
              <div class="mb-2"><b>{{ $t('beingErased') }}</b></div>
              <v-progress-linear indeterminate color="primary"></v-progress-linear> 
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowingUpdateSharingMode" width="60%" :persistent="isUpdatingDossierSharingMode">
      <v-card class="px-12 pb-6">
        <div v-if="!isUpdatingDossierSharingMode">
          <v-layout wrap>
            <v-flex xs12 text-center mt-3>
              <img :src="images.securedData" height="150px"/>
            </v-flex>
            <v-flex xs12 text-center>
              <h3>{{ $t('sharingMode2') }}</h3>
            </v-flex>
            <v-flex xs12 mt-3>
              <v-tabs v-model="activeSharingModeTab" fixed-tabs>
                <v-tab href="#team">
                  {{ $t('y1') }}
                </v-tab>
                <v-tab href="#consultant">
                  {{ $t('y2') }}
                </v-tab>
              </v-tabs>
              <v-divider/>

              <v-tabs-items v-model="activeSharingModeTab" class="mt-6">
                <v-tab-item value="team">
                  <div>
                    <small>
                      <div class="mb-4 text-center"><b>{{ $t('y3') }} {{ getSharingModeAsStr(dossier.sharingMode) }}</b></div>
                      <div class="mb-2"><b>{{ $t('sharingMode3') }}</b></div>
                      <ul>
                        <li><b>{{ $t('sharingModeVal1') }} :</b> {{ $t('sharingModeDescription1') }}</li>
                        <li><b>{{ $t('sharingModeVal2') }} :</b> {{ $t('sharingModeDescription2') }}</li>
                        <li><b>{{ $t('sharingModeVal3') }} :</b> {{ $t('sharingModeDescription3') }}</li>
                        <li><b>{{ $t('sharingModeVal4') }} :</b> {{ $t('sharingModeDescription4') }}</li>
                      </ul>
                    </small>
                    <v-select
                      v-model="newSharingMode"
                      :label="$t('sharingMode4')"
                      :items="allSharingModes"
                      item-text="text"
                      item-value="value"
                      outlined
                      dense
                      class="mt-6"
                    ></v-select>
                    <v-layout wrap mt-3>
                      <v-flex xs6 text-center>
                        <v-btn class="primary" @click="updateSharingMode" :disabled="!newSharingMode">{{ $t('sharingMode5') }}</v-btn>
                      </v-flex>
                      <v-flex xs6 text-center>
                        <v-btn outlined @click="isShowingUpdateSharingMode = false">{{ $t('sharingMode6') }}</v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-tab-item>

                <v-tab-item value="consultant">
                  <small>
                    <v-layout wrap>
                      <v-flex xs12 text-center>
                        <div>
                          <b>{{ $t('y4') }}</b>
                        </div>
                        <div v-if="dossier.invitedConsultantEmail" class="mt-5">
                          <div>
                            <v-chip small>
                              <v-icon small class="mr-2">mdi-link-variant</v-icon>
                              {{ $t('x1') }} - {{ dossier.invitedConsultantEmail }}
                            </v-chip>
                          </div>
                          <div>
                            <v-btn outlined small class="mt-6 mb-2" @click="deleteInvitedConsultantEmail">
                              <v-icon class="mr-1" small>mdi-close</v-icon>
                              {{ $t('y5') }}
                            </v-btn>
                          </div>
                        </div>
                        <div v-else>
                          <div class="text-left ml-6 mt-4">
                            <ul>
                              <li>{{ $t('y6') }}</li>
                              <li>{{ $t('y7') }}</li>
                              <li>{{ $t('y8') }}</li>
                            </ul>
                          </div>

                          <v-layout wrap justify-center mt-6>
                            <v-flex xs12 sm8 text-center>
                              <v-text-field v-model="emailAddressOfConsultantToInvite" type="email" dense outlined :label="$t('y12')" autocomplete="off"/>
                              <v-btn @click="setInvitedConsultantEmail(emailAddressOfConsultantToInvite)" class="primary mb-3" :disabled="!isEmailAddressOfConsultantToInviteOk(emailAddressOfConsultantToInvite)">{{ $t('y9') }}</v-btn>
                            </v-flex>
                          </v-layout>

                          <div v-if="showErrorConsultantWasAlreadyInvited">
                            <v-layout wrap>
                              <v-flex xs12 text-center class="orange--text">
                                <div>{{ $t('y10') }}</div>
                                <div>{{ $t('y11') }}</div>
                                <div class="mt-2">
                                  <v-btn small @click="goToExistingDossierOfConsultant" class="primary">{{ $t('y13') }}</v-btn>
                                </div>
                              </v-flex>
                            </v-layout>
                          </div>

                        </div>
                      </v-flex>
                    </v-layout>
                  </small>
                </v-tab-item>
              </v-tabs-items>

            </v-flex>
          </v-layout>
        </div>
        <div v-else>
          <v-layout wrap>
            <v-flex xs12 text-center>
              <v-progress-linear indeterminate color="primary" class="mt-6"></v-progress-linear> 
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from "vuex"
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import axios from 'axios'

const allLanguages = require('@/assets/app/data/languages.json')

export default {
  props: {
    dossier: Object,
    isShowingAllDossiersOfTheCompany: Boolean
  },
  data: () => ({
    showCopySuccess: false,
    isShowingAllTechnicalSkillNames: false,
    isShowingArchiveDossier: false,
    erasingDossierStatus: 'notStarted',
    isDownloadingOriginalCV: false,
    isShowingUpdateSharingMode: false,
    isUpdatingDossierSharingMode: false,
    newSharingMode: null,
    allSharingModes: [],
    activeSharingModeTab: 'team',
    showErrorConsultantWasAlreadyInvited: false,
    emailAddressOfConsultantToInvite: '',
    images: {
      securedData: require('@/assets/app/images/security_flatline.svg'),
    }
  }),
  async mounted() {
    // console.log(JSON.stringify(this.dossier)); // eslint-disable-line
    this.allSharingModes = [
      { value: 'editable', text: this.$t('sharingModeVal1'), description: this.$t('sharingModeDescription1') },
      { value: 'downloadable', text: this.$t('sharingModeVal2'), description: this.$t('sharingModeDescription2')  },
      { value: 'visible', text: this.$t('sharingModeVal3'), description: this.$t('sharingModeDescription3')  },
      { value: 'hidden', text: this.$t('sharingModeVal4'), description: this.$t('sharingModeDescription4')  },
    ]
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    wasDossierTranslated() {
      return this.dossier.profile.cvLanguage !== this.dossier.profile.originalCvLanguage
    },
    translatedToStr() {
      const language = {
        'FR': this.$t('n1'),
        'EN': this.$t('n2'),
        'DE': this.$t('n3'),
        'ES': this.$t('n4'),
        'IT': this.$t('n5'),
        'PT': this.$t('n6'),
        'NL': this.$t('n7'),
        'RU': this.$t('n8'),
      }[this.dossier.profile.cvLanguage]
      return `${this.$t('n')} ${language}.`
    },
    dossierStatus() {
      return this.dossier.status
    },
    isMyDossier() {
      return this.dossier.userId && this.dossier.userId === this.$auth.currentUser.uid
    },
    editDossierRouterPath() {
      let path = `/dossiers/${this.dossier.id}/edit?showOnlyThisDossierAfterCreateDossier=1`
      if (this.isShowingAllDossiersOfTheCompany) path += '&showAllDossiersOfTheCompanyAfterCreateDossier=1'
      return path
    }
  },
  methods: {
    displayDate(timestamp) {
      return new Date(timestamp).toLocaleDateString()
    },
    async downloadOriginalCV() {
      this.isDownloadingOriginalCV = true
      const response = await this.$functions.httpsCallable('getOriginalCvDownloadUrl')({ dossierId: this.dossier.id })
      await this.haveUserDownloadFile(response.data.url, true)
      this.isDownloadingOriginalCV = false
    },
    async downloadDossier() {
      const url = await this.$storage.ref(this.dossier.downloadUrl).getDownloadURL()
      this.haveUserDownloadFile(url, false)
    },
    forceFileDownload(response, isOriginalCV) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.style.display = 'none';
      link.href = url
      const originalCvExtension = ('.' + this.dossier.sourceUrl.split('.')[this.dossier.sourceUrl.split('.').length - 1]).toLowerCase()
      let fileName;
      if (isOriginalCV) {
        fileName = ['CV original', this.dossier.fullName].filter(Boolean).join(' ').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, ' ') + originalCvExtension
      } else {
        fileName = ['CV', this.dossier.fullName].filter(Boolean).join(' ').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, ' ') + '.docx'
        // Special request for HN Services France (companyId = '6IkhQHPkUytkZEDeI47e')
        if (this.user.data.companyId === '6IkhQHPkUytkZEDeI47e') fileName = `Dossier de Compétences HN_${this.dossier.profile.trigram.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, ' ')}.docx`
        // Special request for HN Services Portugal (companyId = 't5kzxfyYjcsoITYNrai9' )
        if (this.user.data.companyId === 't5kzxfyYjcsoITYNrai9') fileName = ([[this.dossier.profile.lastName.toUpperCase(), this.dossier.profile.firstName].filter(Boolean).join(' '), this.dossier.profile.title].filter(Boolean).join(' - ').replace(/[`~!@#$%^&*()_|+=?;:'",.<>{}[\]\\/]/gi, ' ') || 'CV' ) + '.docx'
        // Special request for We+ (companyId = 'TEm88E2eL1Jijvhy5yg3' )
        if (this.user.data.companyId === 'TEm88E2eL1Jijvhy5yg3') fileName = (this.dossier.profile.firstName || this.dossier.profile.trigram) ? `WE+ DC${(this.dossier.profile.firstName || this.dossier.profile.trigram).replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, ' ') }.docx` : `WE+ DC.docx`
        // Special request for Winside (companyId = 'CEGcgY4FAngaAyqTUntr' )
        if (this.user.data.companyId === 'CEGcgY4FAngaAyqTUntr') fileName = ([this.dossier.profile.firstName, this.dossier.profile.lastName.toUpperCase()].filter(Boolean).join(' ').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, ' ') || 'CV') + ' - Winside.docx'
        // Special request for Catamania (companyId = 'VyCv7C5kb2Xv8rm1i2lc' )
        if (this.user.data.companyId === 'VyCv7C5kb2Xv8rm1i2lc') fileName = ([this.dossier.profile.lastName.toUpperCase(), this.dossier.profile.firstName].filter(Boolean).join(' ').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, ' ') || 'CV' ) + '.docx'
        // Special request for Ozitem (companyId = 'RHrLtXB3zht78kQNvd39' )
        if (this.user.data.companyId === '9bD5dBPTtcxlGccfHKBc') {
          // OZITEM - 1ère lettre prénom + 2 premières lettres nom (Prénom) - Intitulé de poste - DC V0.9 - Mois.année
          // ex: OZITEM - RCH (Ruddy) - Admin-Ingé PDT - DC V0.9 - MRS.23
          // Create a new Date object
          const currentDate = new Date();
          const currentMonth = currentDate.getMonth() + 1; // Months are zero-based, so we add 1
          const currentYear = currentDate.getFullYear();
          const formattedDate = `${currentMonth.toString().padStart(2, '0')}.${currentYear.toString().slice(-2)}`;
          // formattedDate will actually be 03.23
          fileName = `OZITEM - ${this.dossier.profile.trigram} (${this.dossier.profile.firstName}) - ${this.dossier.profile.title} - DC V0.9 - ${formattedDate}.docx`
        }
        // Oiseau rare
        if (this.user.data.companyId === 'IkJOx421mTfVFumqbRfm') fileName = (['OR', this.dossier.profile.firstName].filter(Boolean).join(' - ').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, ' ') || 'CV' ) + '.docx'
        // Metanext
        if (this.user.data.companyId === '5EkQmEQm8kt7BOr4FxPt') {
          // [METANEXT] FDC - Titre - Prénom.N - 2024mm
          fileName = `[METANEXT] FDC`
          if (this.dossier.profile.title) fileName += ` - ${this.dossier.profile.title}`
          fileName += ` - ` + [this.dossier.profile.firstName, (this.dossier.profile.lastName.length > 0 ? this.dossier.profile.lastName[0] : '')].filter(Boolean).join('.')
          
          const currentDate = new Date();
          const currentMonth = currentDate.getMonth() + 1; // Months are zero-based, so we add 1
          const currentYear = currentDate.getFullYear();
          const formattedDate = `${currentYear.toString().slice(-2)}${currentMonth.toString().padStart(2, '0')}`;
          // formattedDate is 202409 for september
          fileName += ` - ${formattedDate}.docx`
        }
      }
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    haveUserDownloadFile(url, isOriginalCV) {
      return new Promise(resolve => {
        axios({
          method: 'get',
          url,
          responseType: 'arraybuffer',
        })
        .then((response) => {
          this.forceFileDownload(response, isOriginalCV)
        })
        .then(() => {
          resolve()
        })
        .catch(() => console.log('error occured'))
      })
    },
    getLanguageName(languageCode) {
      const interfaceLanguage = this.user.data.locale // 'fr' or 'en'
      return allLanguages.find(l => l.iso_code === languageCode).descriptions[interfaceLanguage]
    },
    async eraseDossier() {
      this.erasingDossierStatus = 'pending'
      await this.$functions.httpsCallable('eraseDossier')({
        dossierId: this.dossier.id
      })
      this.erasingDossierStatus = 'success'
      this.$emit('updateAlgoliaResults')
      this.dossier.isErased = true
      this.isShowingArchiveDossier = false
    },
    async updateSharingMode() {
      this.isUpdatingDossierSharingMode = true
      await this.$functions.httpsCallable('updateDossierSharingMode')({
        dossierId: this.dossier.id,
        sharingMode: this.newSharingMode
      })
      this.$emit('updateAlgoliaResults')
      this.dossier.sharingMode = this.newSharingMode
      this.isShowingUpdateSharingMode = false
      setTimeout(() => {
        this.isUpdatingDossierSharingMode = false
      }, 1000)
    },
    getSharingModeAsStr(sharingMode) {
      const mode = this.allSharingModes.find(x => x.value === sharingMode)
      return mode ? mode.text : ''
    },
    getSharingModeDescriptionAsStr(sharingMode) {
      const mode = this.allSharingModes.find(x => x.value === sharingMode)
      return mode ? mode.description : ''
    },
    showUpdateSharingModeDialog(tabId) {
      this.activeSharingModeTab = tabId
      this.isShowingUpdateSharingMode = true
    },
    async deleteInvitedConsultantEmail() {
      await this.setInvitedConsultantEmail(null)
    },
    async setInvitedConsultantEmail(newInvitedConsultantEmail) {
      this.isUpdatingDossierSharingMode = true
      const response = await this.$functions.httpsCallable('setInvitedConsultantEmailOfExistingDossier')({
        dossierId: this.dossier.id,
        invitedConsultantEmail: newInvitedConsultantEmail
      })
      if (response.data && response.data.errorCode === 'consultant-was-already-invited-to-create-a-dossier') {
        this.showErrorConsultantWasAlreadyInvited = true
        this.isUpdatingDossierSharingMode = false
      } else {
        this.$emit('updateAlgoliaResults')
        this.isShowingUpdateSharingMode = false
        setTimeout(() => {
          this.isUpdatingDossierSharingMode = false
        }, 1000)
      }
    },
    isEmailAddressOfConsultantToInviteOk(email) {
      email = email.trim()
      if (!email || !/.+@.+\..+/.test(email)) return false
      return true
    },
    goToExistingDossierOfConsultant() {
      this.$emit('goToExistingDossierOfConsultant', { emailAddressOfConsultantToInvite: JSON.stringify(this.emailAddressOfConsultantToInvite) })
      setTimeout(() => {
        this.isShowingUpdateSharingMode = false
      },1)
    },
    getLabelById(labelId) {
      return this.user.company.labels.find(label => label.id === labelId)
    }
  },
  watch: {
    isShowingUpdateSharingMode: {
      handler(val) {
        if (!val) {
          this.newSharingMode = null
          this.emailAddressOfConsultantToInvite = ''
        }
      }
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Créé le",
    "b": "Télécharger le CV original",
    "c": "Vous pourrez télécharger le dossier après la validation de votre compte",
    "d": "Dossier en cours de création",
    "e": "Erreur lors de la création du dossier.",
    "e2": "Nous n'avons pas réussi à suffisamment compresser votre fichier pour qu'il soit en dessous de notre limite de 2MB.<br><br>Pourriez-vous réessayer avec un fichier plus léger ?",
    "f": "Ce dossier n'est pas compté dans votre abonnement.",
    "f3": "Pouvez-vous essayer à nouveau en cliquant sur \"Éditer\" puis \"Créer le dossier\" ?",
    "g": "Télécharger",
    "j": "Nous ferons tout pour vous apporter le meilleur outil possible<br>et vous faire gagner toujours plus de temps.",
    "k": "Que pensez-vous de ce dossier ?",
    "l": "Que pouvons-nous améliorer ?",
    "m": "Envoyer",
    "n": "Traduit en",
    "n1": "Français",
    "n2": "Anglais",
    "n3": "Allemand",
    "n4": "Espagnol",
    "n5": "Italien",
    "n6": "Portugais",
    "n7": "Néerlandais",
    "n8": "Russe",
    "edit": "Éditer",
    "1": "an d'expérience.",
    "1plural": "ans d'expérience.",
    "2": "Voir moins",
    "3": "Voir plus",
    "4": "par",
    "4bis": "par le consultant.",
    "4ter": "par API.",

    "5": "Supprimer les données de ce dossier ?",
    "6": "Les données liées à ce dossier seront définitivement supprimées : CV original, informations du profil et dossier de compétences généré.",
    "7": "Supprimer",
    "8": "Annuler",
    "beingErased": "Suppression du dossier en cours",
    "erased": "Ce dossier a été supprimé.",

    "x1": "Consultant invité",
    "x2": "Le consultant n'a pas encore uploadé son CV.",

    "sharingModeVal1": "Éditable",
    "sharingModeDescription1": "Tout membre de l'équipe peut éditer, télécharger ou supprimer le dossier.",
    "sharingModeVal2": "Téléchargeable",
    "sharingModeDescription2": "Tout membre de l'équipe peut télécharger le dossier.",
    "sharingModeVal3": "Visible",
    "sharingModeDescription3": "Tout membre de l'équipe peut voir les informations du profil mais ne peut pas accéder au dossier ni au CV original.",
    "sharingModeVal4": "Invisible",
    "sharingModeDescription4": "Ce profil n'apparaît pas dans la liste pour les autres utilisateurs.",

    "sharingMode0": "Partage",
    "sharingMode1": "Mode de partage du dossier :",
    "sharingMode2": "Modifier l'accès au dossier",
    "sharingMode3": "Vous pouvez choisir de restreindre l'accès à ce dossier pour tous les autres utilisateurs de votre équipe.",
    "sharingMode4": "Nouvel accès au dossier par votre équipe",
    "sharingMode5": "Mettre à jour",
    "sharingMode6": "Annuler",


    "y1": "Votre équipe",
    "y2": "Consultant",
    "y3": "Mode actuel de partage à votre équipe :",
    "y4": "Vous pouvez choisir d'inviter un consultant à éditer les informations de ce dossier.",
    "y5": "Supprimer l'accès de ce consultant à ce dossier",
    "y6": "Le consultant sera invité par email.",
    "y7": "Il pourra uploader son CV et éditer les informations de son profil dans le formulaire.",
    "y8": "Vous pourrez ensuite vous-même éditer ces informations si besoin et télécharger son dossier.",
    "y9": "Inviter",
    "y10": "Invitation non envoyée.",
    "y11": "Le consultant avait déjà été invité à créer son dossier.",
    "y12": "Adresse email du consultant",
    "y13": "Voir le dossier"
  },
  "en": {
    "a": "Created on",
    "b": "Download original CV",
    "c": "You will be able to download your CV after validation of your account",
    "d": "Your CV is being created",
    "e": "Sorry, an error occurred while creating your CV.",
    "e2": "We tried to compress your CV file, but we couldn't reduce its size below our 2MB limit.<br><br>Could you please try again with a smaller file ?",
    "f": "This CV is not counted in your subscription.",
    "f3": "Can you try again by clicking on \"Edit\" and then \"Create CV\" ?",
    "g": "Download CV",
    "j": "We will do everything in our power to bring you the best solution<br>and always save you more time.",
    "k": "How good is the new CV ?",
    "l": "What can we improve ?",
    "m": "Send",
    "n": "Translated to",
    "n1": "French",
    "n2": "English",
    "n3": "German",
    "n4": "Spanish",
    "n5": "Italian",
    "n6": "Portuguese",
    "n7": "Dutch",
    "n8": "Russian",
    "edit": "Edit",
    "1": "year of experience.",
    "1plural": "years of experience.",
    "2": "See less",
    "3": "See more",
    "4": "by",
    "4bis": "by the consultant.",
    "4ter": "by API.",

    "5": "Delete data related to this CV ?",
    "6": "Data linked to this CV will definitely be deleted : original resume, profile's data, created CV.",
    "7": "Delete",
    "8": "Cancel",
    "beingErased": "This CV is being deleted...",
    "erased": "This CV has been deleted.",

    "x1": "Consultant invited",
    "x2": "The consultant hasn't uploaded his CV yet.",

    "sharingModeVal1": "Editable",
    "sharingModeDescription1": "Anyone in the team can edit, download or delete the CV.",
    "sharingModeVal2": "Downloadable",
    "sharingModeDescription2": "Anyone in the team can download the CV.",
    "sharingModeVal3": "Visible",
    "sharingModeDescription3": "Anyone in the team can see the profile data but cannot access the new CV nor the original one.",
    "sharingModeVal4": "Invisible",
    "sharingModeDescription4": "This profile doesn't appear in the other users' lists.",

    "sharingMode0": "Sharing",
    "sharingMode1": "Sharing setting:",
    "sharingMode2": "Edit access to the CV",
    "sharingMode3": "You can choose to limit access to this CV's data for all users of your team.",
    "sharingMode4": "New sharing setting for your team",
    "sharingMode5": "Update",
    "sharingMode6": "Cancel",

    
    "y1": "Your team",
    "y2": "Consultant",
    "y3": "Current sharing mode with your team :",
    "y4": "You can invite a consultant to edit the data of this CV.",
    "y5": "Remove access of this consultant to this CV",
    "y6": "The consultant will be invited by email.",
    "y7": "He will be asked to upload his CV and edit his profile data in the usual form.",
    "y8": "You will then be able to also edit this data if needed and download the new CV.",
    "y9": "Invite",
    "y10": "Invitation was not sent.",
    "y11": "The consultant had already been invited to create his CV.",
    "y12": "Email address of the consultant",
    "y13": "See the CV"
  }
}
</i18n>

<style scoped>
.ais-Hits-item {
  padding-right: 0px !important;
}

.v-tooltip__content {
  background-color: #37474f;
  opacity: 1 !important;
}
</style>